
export interface ISubmitContributorData {
    iepFormSk?: string;
    sectionId?: string | number;
    personSk?: string;
    role?: number;
    lastModuser?: string;
    lastModTS?: Date;
    personName?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    email?: string;
    phone?: string;
    title?: string;
    operationType?: number;
    loginId?:string
}

export class SubmitContributorData {
    caseActionSK: string;
    personSK: string;
    iepFormSK: string
    sectionId: string | number;
    role: number;
    iepSection: number | string;
    lastModuser: string;
    lastModTS: Date;
    personName: string;
    firstName: string; 
    lastName: string; 
    middleName: string; 
    email: string; 
    phone: string; 
    title: string; 
    operationType: number;
    loginId?: string;
    constructor(contributorData: Partial<ISubmitContributorData>) {       
        this.caseActionSK = contributorData.iepFormSk;
        this.iepFormSK = contributorData.iepFormSk;
        this.sectionId = contributorData.sectionId;
        this.personSK = contributorData.personSk;
        this.role = contributorData.role;
        this.iepSection = contributorData.sectionId;
        this.lastModuser = contributorData.lastModuser;
        this.lastModTS = contributorData.lastModTS;
        this.personName = contributorData.personName;
        this.firstName = contributorData.firstName;
        this.lastName = contributorData.lastName;
        this.middleName = contributorData.middleName;
        this.email = contributorData.email;
        this.phone = contributorData.phone;
        this.title = contributorData.title;
        this.operationType = contributorData.operationType;
        this.loginId = contributorData.loginId
    }
    get id(): string {
        return this.caseActionSK
    }
}
